import React from "react";
import "./About.css";
import technopark from "../images/technopark.jpg";
import banking from "../images/reporting.jpg";

const About = () => {
  return (
    <>
      <div
        className="bg-container-about"
        style={{ backgroundImage: `url(${technopark})` }}
      ></div>

      <div className="about-wrapper">
        <div className="about-hero-content">
          <h1>About IGNOSI</h1>
          <h2>Transforming traditional banking into intelligent, secure, and inclusive financial ecosystems.</h2>
          <p>
            IGNOSI is a next-generation fintech and banking technology company delivering intelligent SaaS platforms for banks, credit societies and entrepreneurs.
          </p>
          <ul>
            <li>Intelligent SaaS Platforms</li>
            <li>Automated Lending Systems</li>
            <li>Deposit Management Solutions</li>
            <li>Compliance-Ready Bookkeeping</li>
          </ul>
        </div>
      </div>

      {/* COMPANY OVERVIEW SECTION */}
      <div className="about-overview-section">
        <div className="about-overview-container">
          <div className="about-text-content">
            <h3>A better home to shape your software.We have a passion for crafting powerful technologies to shape your ideas into reality</h3>
            <p>
              IGNOSI - Your All-In-One SAAS modal industry specific core banking software solution, seamlessly managing KYC, deposit, loan, and statutory books of accounts with intuitive core banking features
We are a specialized fintech company focused on building industry-specific core banking and financial software that is adaptable, scalable, intuitive, and responsive to your real-world needs.

            </p>
          </div>
          <div className="about-image-content">
            <img src={banking} alt="Banking Tech" />
          </div>
        </div>
      </div>

      {/* VISION & MISSION SECTION */}
      <div className="vision-mission-section">
        <div className="vision-mission-grid">
          <div className="vision-card">
            <div className="vision-icon">👁️</div>
            <h3>Our Vision</h3>
            <p>
              IGNOSI envisions reshaping banking by elevating traditional practices into intelligent, inclusive financial ecosystems. We empower entrepreneurs and socially driven credit providers with cutting-edge technology that expands financial inclusion and broadens access to modern credit management.
            </p>
          </div>
          <div className="vision-card">
            <div className="vision-icon">🚀</div>
            <h3>Our Mission</h3>
            <p>
              Our mission is to create financial software that is practical, precise, and built for longevity.
We develop software that brings structure to complex workflows, control to financial operations, and reliability to compliance-driven environments. Every product we build is guided by precision, auditability, and real-world usability—ensuring that technology strengthens governance rather than complicating it.
Through disciplined innovation and close partnership with our clients, we aim to become the backbone on which financial institutions confidently manage growth and responsibility.

            </p>
          </div>
        </div>
      </div>
       <div className="fintech-container">

        {/* HEADER */}
        <div className="fintech-header">
          <h2>Building Intelligent Financial Technology</h2>
          <p>
            IGNOSI combines deep financial domain expertise with modern
            engineering excellence to deliver scalable and regulation-ready
            digital platforms.
          </p>
        </div>

        {/* ABOUT GRID */}
        <div className="fintech-grid">

          <div className="fintech-card large">
            <h3>Who We Are</h3>
            <p>
              Our team blends software engineers, banking domain experts,
              NBFC and cooperative specialists, and consultants who understand
              real-world financial operations.
            </p>
            <p>
              Trusted by 1,600+ institutions, IGNOSI powers mission-critical
              financial ecosystems across the region.
            </p>
          </div>

          <div className="fintech-card">
            <h3>What We Do</h3>
            <ul>
              <li>Automate financial operations</li>
              <li>Maintain compliant accounting systems</li>
              <li>Reduce operational risk & fraud</li>
              <li>Improve customer turnaround</li>
              <li>Ensure audit readiness</li>
            </ul>
          </div>

          <div className="fintech-card">
            <h3>Why IGNOSI</h3>
            <ul>
              <li>Domain-driven financial architecture</li>
              <li>End-to-end banking lifecycle coverage</li>
              <li>2000+ satisfied institutions</li>
              <li>AI & future-ready innovation</li>
              <li>Ethics-driven engineering culture</li>
            </ul>
          </div>

        </div>

        {/* PROMISE STRIP */}
        <div className="fintech-promise">
          <h3>
            We build the digital backbone of modern financial enterprises.
          </h3>

          <p>
            IGNOSI – Intelligent Lending. A safer way to scale your finance.
          </p>
        </div>

      </div>

      {/* WHY CHOOSE IGNOSI */}
      <div className="features-section-about">
        <h2 className="section-title-about">Why Choose IGNOSI</h2>
        <div className="features-grid-about">
          {[
            { title: "Skilled Developers", desc: "Expert team delivering robust fintech solutions." },
            { title: "Creative Graphic Designers", desc: "Crafting unique and modern user interfaces." },
            { title: "Pixel Perfect Design", desc: "Ensuring flawless display across all devices." },
            { title: "On-time Delivery", desc: "Commitment to project timelines and milestones." },
            { title: "Corporate Software", desc: "Enterprise-grade services for banking needs." },
            { title: "Systematic Approach", desc: "Structured workflows for maximum efficiency." },
            { title: "SEO & Support", desc: "Helping your platform reach the right audience." },
            { title: "Quality Results", desc: "Fast turnaround without compromising quality." },
          ].map((item, index) => (
            <div className="feature-card-about" key={index}>
              <div className="feature-bar-about">{item.title}</div>
              <div className="feature-hover-about">
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* COMPLIANCE & SECURITY */}
      <div className="stats-section-about">
        <h2 className="stats-title-about">Compliance & Security Standards</h2>
        <div className="stats-grid-about">
          {[
            { icon: "🛡️", title: "RBAC", desc: "Role-based Access Control" },
            { icon: "📜", title: "Audit Trails", desc: "Comprehensive transaction logs" },
            { icon: "🔒", title: "Encryption", desc: "Data protection at rest & transit" },
            { icon: "🏛️", title: "Readiness", desc: "Regulatory & Audit preparations" },
          ].map((item, index) => (
            <div className="stat-card-about" key={index}>
              <div className="stat-icon-about">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default About;